import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { translate } from "react-translate";
import _ from 'lodash'

//IMPORT IMAGES
import Travaux from '../../../assets/svg/Travaux.svg';
import Parametres from '../../../assets/svg/Parametres.svg';
import Listes from '../../../assets/svg/Listes.svg';
import Magasins from '../../../assets/svg/Magasins.svg';
import Extensions from '../../../assets/svg/Extensions.svg';
import Contact from '../../../assets/svg/Contact.svg';
import Home from '../../../assets/icons/Home.png';
import TravauxNew from '../../../assets/svg/TravauxNew.svg';
import Parquet from '../../../assets/svg/Parquet.svg';
import Cloture from '../../../assets/svg/Cloture.svg';
import Murs from '../../../assets/svg/Murs.svg';
import BigHome from '../../../assets/svg/BigHome.svg';
import News from '../../../assets/svg/News.svg';
import zoum from '../../../assets/icons/zoum.png';
import renommer from '../../../assets/svg/renommer.svg';
import supprimer from '../../../assets/svg/supprimer.svg';
import createList from '../../../assets/icons/createList.png';
import ListesNew from '../../../assets/svg/ListesNew.svg';
import Magasins2 from '../../../assets/svg/Magasins2.svg';
import bg2 from '../../../assets/icons/bg2.png';
import bg from '../../../assets/icons/bg.png';

//IMPORT REACT COMPONENTS
// import Lists from './Lists.js';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Modal,

} from 'semantic-ui-react';
import './listesComponents.css'
import './modal_list.css'

//IMPORT REDUX
import { connect } from 'react-redux';

//import redux new
import { addPkuidlist } from '../../../redux/actions/AppAction'
import ListoComponent from './ListoComponent';
import AddList from './AddList';
import CreateList from './CreateList';

import { Currencies } from '../../../constants/Currencies';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app,
		list: state.list
})

const mapActionToProps = {
    addPkuidlist: addPkuidlist
}

class ConnectedListesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: null,
            pkuidlist: null,
            response: null,
            modalOpen: false,
            showResults: null,
            isLoading: false,
            source: [],
            searchResults: [],
            value: '',
            currency: '€',
        }
        this.setPkuidlist = this.setPkuidlist.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleResultSelect = this.handleResultSelect.bind(this)
    }

    handleOpen = () => this.setState({
        modalOpen: true
    })

    handleClose = () => this.setState({
        modalOpen: false,

    }, this.componentWillMount)

    componentWillMount() {
        var pwd = this

        API.getUser(this.props.app.token).then((res) => {
            let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
            pwd.setState({
                currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
            })
        });

				if (this.props.list && this.props.list.list) {
					// set filter models
					let source = this.convertToSearchModel(this.props.list.list)
					this.setState({
							response: this.props.list.list,
							showResults: this.props.list.list,
							source: source
					})
				}
    }

		componentWillReceiveProps(nextProps) {
			if (nextProps.list && nextProps.list.list) {
				// set filter models
				let source = this.convertToSearchModel(nextProps.list.list)
				this.setState({
						response: nextProps.list.list,
						showResults: nextProps.list.list,
						source: source
				})
			}
	  }

    setPkuidlist(pkuidlist) {
        this.props.addPkuidlist(pkuidlist)
    }

    handleChangeName(event) {
        event.preventDefault();
        this.setState({ name: event.target.value });
    }

    resetComponent() {
        this.setState({
            isLoading: false,
            searchResults: [],
            showResults: this.props.list.list,
            value: ''
        })
    }

    convertToSearchModel(list) {
        const { t } = this.props;
        let source = []
        Object.entries(list).map((key, mainindex) => {
            if (key[0] !== 'code' && key[0] !== 'msg') {
                let sourceValue = {
                    title: key[1].name,
                    description: <div>
																	{ `${t('goods')}: ${key[1].nb_article}` }
																	<br/>
																	{ `${t('Amount')}: ${(key[1].quantite ? key[1].quantite : '0')}` }
																</div>,
                    image: null,
                    price: key[1].prix + ' ' + this.state.currency,
                    response_key: key[0],
                }
                source.push(sourceValue);
            }
        })

        return source;
    }

    handleResultSelect(e, { result }) {
        let showResults = {}
        showResults[result.response_key] = this.state.response[result.response_key]
        this.setState({
            value: result.title,
            showResults: showResults
        })
    }

    handleSearchChange(e, { value }) {
        this.setState({
            isLoading: true, value
        })

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent()

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
            const isMatch = result => re.test(result.title)
            let searchResults = _.filter(this.state.source, isMatch)
            let showResults = {}
            for (let i = 0; i < searchResults.length; i++) {
                showResults[searchResults[i].response_key] = this.state.response[searchResults[i].response_key]
            }

            this.setState({
                isLoading: false,
                searchResults: searchResults,
                showResults: showResults
            })
        }, 300)
    }


    render() {
        var segmentStyle = {
            height: '100px',
        }
        const { t } = this.props;
        const { isLoading, value, searchResults, showResults } = this.state

        return (
            <div>
                <Grid stackable id="listesHeader">
                    <Grid.Row columns={3} id="headerSection">
                        <Grid.Column verticalAlign='middle' mobile={16} tablet={5} computer={4}>
                            <Segment basic>
                                <Item.Image size='mini' src={ListesNew} id="imageSection" />
                                <Item.Content verticalAlign='middle'>
                                    <Item.Header as='h3' id="titleSection">{t("Item1_title")}</Item.Header>
                                </Item.Content>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column verticalAlign='middle' mobile={16} tablet={6} computer={8}>
                            <Search id='SearchColumn' input={{ fluid: 'true' }} placeholder={t("filter_list")}
                                loading={isLoading}
                                onResultSelect={this.handleResultSelect}
                                onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                                results={searchResults}
                                value={value}
                                className={this.state.searchResults.length >= 1 ? 'search_bar' : ''}
                                {...this.props}
                            />
                        </Grid.Column>
                        <Grid.Column textAlign='center' verticalAlign='middle' mobile={16} tablet={5} computer={4}>
                            <CreateList />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                {/* Headers of table */}
                <Grid stackable id="header-list-title">
                    <Grid.Row columns={5} style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <Grid.Column width={5} style={{ marginLeft: '10px', color: '#53637c' }}>
                            <h4 id="headerCellTitleList">{t("HeaderCell1_title")}</h4>
                        </Grid.Column>
                        <Grid.Column width={2} style={{ color: '#53637c' }}>
                              <h4 id="headerCellTitleList">{t("HeaderCell2_title")}</h4>
                        </Grid.Column>
                        <Grid.Column width={2} style={{ color: '#53637c' }}>
                              <h4 id="headerCellTitleList">{t("HeaderCell3_title")}</h4>
                        </Grid.Column>
                        <Grid.Column style={{ color: '#53637c' }}>
                              <h4 id="headerCellTitleList">{t("HeaderCell4_title")}</h4>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <ListoComponent showResults={showResults ? showResults : []}/>
            </div>
        );
    }
}



const ListesComponent = connect(mapStateToProps, mapActionToProps)(ConnectedListesComponent);
export default translate("ListesComponent")(ListesComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/ListesComponent.js